<template>
  <div>
    <div class="row">
      <div class="col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12 pl-0">
        <div
          v-for="item in tabs"
          :key="item.step"
          class="d-flex align-items-center"
        >
          <button
            @click="handleStep(item.step)"
            :outlined="step != item.step"
            :class="[
              step == item.step && 'btn-nav-menu',
              step != item.step && 'btn-nav-menu1',
            ]"
          >
            <strong>{{ item.title }}</strong>
          </button>
          <div
            :class="[
              step == item.step && 'triangulo-para-direita',
              step != item.step && 'triangulo-none',
            ]"
          ></div>
        </div>
      </div>
      <div class="col-xl-10 col-lg-10 col-md-9 col-sm-12 col-12 pt-0 pl-0 pr-0">
        <Providers v-if="step == 'PROVIDERS'" />
        <Classifications v-if="step == 'CLASSIFICATIONS'" />
      </div>
    </div>
  </div>
</template>

<script>
import Providers from "./Provider/Providers";

import Classifications from "./Provider/Classifications";

export default {
  name: "Provider",

  components: {
    Providers,
    Classifications,
  },

  data() {
    return {
      tabs: [
        { title: "FORNECEDORES", step: "PROVIDERS" },
        { title: "CLASSIFICAÇÕES", step: "CLASSIFICATIONS" },
      ],
      step: "PROVIDERS",
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    handleStep(step) {
      let newMenu = step.toLowerCase();
      let { nav, menu } = this.$router.currentRoute.query;

      if (menu != newMenu)
        this.$router.replace({ query: { nav, menu: newMenu } });

      this.step = step;
    },

    retrieve() {
      const { nav, menu } = this.$router.currentRoute.query;

      if (menu) {
        let step = menu.toUpperCase();

        this.step = step;
      } else {
        this.$router.replace({ query: { nav, menu: "providers" } });
      }
    },
  },
};
</script>
